<template>
	<section v-if="items.length" class="faq-section border-top">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="item in items" :key="item.ID" class="faq-item">
					<collapse :header="item.question" :content="item.answer" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-section {
	position: relative;
	z-index: 2;
}

.faq-item {
	text-align: left;
	overflow: hidden;
	margin: 0 0 20px;
}

.faq-row {
	margin-bottom: 30px;
	max-width: 1080px;
}

.border-top {
	padding: 75px 0;
}
</style>
